module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-60\">Format</label>\r\n        <div>\r\n            <div id=\"main_text_format\">\r\n                <select id=\"format\" name=\"format\">\r\n                    <option value=\"none\">None</option>\r\n                    <option value=\"alpha\">Alpha</option>\r\n                    <option value=\"numeric\">Numeric</option>\r\n                    <option value=\"alphanumeric\">Alphanumeric</option>\r\n                    <option value=\"email\">Email</option>\r\n                    <option value=\"url\">URL</option>\r\n                    <option value=\"phone\">Phone</option>\r\n                    <option value=\"text\">Text</option>\r\n                    <option value=\"custom\">Custom</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    \r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-60\">&nbsp;</label>\r\n        <div>\r\n            <div id=\"main_text_custom\">\r\n                <input id=\"customFormat\" name=\"customFormat\" type=\"text\" value=\"")
    ; __append(escapeFn( customFormat ))
    ; __append("\" disabled/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}